import { Component } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { EasymarineAiService } from './easymarine-ai.service';

/**
 * Cortina do EasyMarine AI (padrão quickview do admin, aberta pelo ícone do cabeçalho): a tela em modo compacto
 * (/ia/?modo=cortina). O iframe só é criado na primeira abertura e continua carregado depois de fechar, para a
 * resposta em andamento seguir (o ícone mostra o anel e, no fim, a bolinha).
 */
@Component({
    selector: 'my-easymarine-ai-cortina',
    template: `
        <section *ngIf="easymarineAi.disponivel" class="quickview-wrapper easymarine-ai-cortina" id="quickview-easymarine-ai"
                 [attr.aria-hidden]="!easymarineAi.cortinaAberta" [attr.aria-label]="'EASYMARINE-AI' | translate">
            <header class="easymarine-ai-cortina-topo">
                <span class="easymarine-ai-cortina-titulo">{{ 'EASYMARINE-AI' | translate }}</span>
                <a class="easymarine-ai-cortina-fechar" href="javascript:;" (click)="easymarineAi.fecharCortina()"
                   [attr.aria-label]="'EASYMARINE-AI-CLOSE' | translate" [title]="'EASYMARINE-AI-CLOSE' | translate">
                    <span class="material-icons">close</span>
                </a>
            </header>
            <iframe *ngIf="easymarineAi.cortinaCarregada" [src]="endereco" (load)="aoCarregar($event.target)"
                    title="EasyMarine AI" class="easymarine-ai-cortina-iframe"></iframe>
        </section>
    `
})
export class EasymarineAiCortinaComponent {
    readonly endereco: SafeResourceUrl;

    constructor(public easymarineAi: EasymarineAiService, sanitizer: DomSanitizer) {
        // caminho fixo da própria origem
        this.endereco = sanitizer.bypassSecurityTrustResourceUrl(easymarineAi.enderecoDaTela + '?modo=cortina');
    }

    aoCarregar(iframe: HTMLIFrameElement): void {
        if (iframe) {
            this.easymarineAi.registrarCortina(iframe);
        }
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/easymarine-ai/easymarine-ai-cortina.component.ts